import criticalStockApi from '@/api/criticalStock';

const state = {
  myLines: [],
  allLines: [],
  canViewAll: false,
};

const getters = {
  myLines: (s) => s.myLines,
  allLines: (s) => s.allLines,
  canViewAll: (s) => s.canViewAll,
  // Kullanıcının uyarı sayıları (rozet/badge için).
  myWarningCounts: (s) => ({
    below: s.myLines.filter((l) => l.status === 2).length,
    out: s.myLines.filter((l) => l.status === 3).length,
  }),
};

const actions = {
  async getMyCriticalStock({ commit }, onlyWarnings = false) {
    const { data } = await criticalStockApi.getMy(onlyWarnings);
    commit('setMyLines', data || []);
    return data || [];
  },
  async saveMyCriticalStock(_ctx, items) {
    const { data } = await criticalStockApi.saveMy(items);
    return data;
  },
  async getAllCriticalStock({ commit }, payload) {
    const p = payload || {};
    const { data } = await criticalStockApi.getAll(p.userId, p.onlyWarnings);
    commit('setAllLines', data || []);
    return data || [];
  },
  async getCanViewAll({ commit }) {
    try {
      const { data } = await criticalStockApi.canViewAll();
      commit('setCanViewAll', !!data);
      return !!data;
    } catch (e) {
      commit('setCanViewAll', false);
      return false;
    }
  },
};

const mutations = {
  setMyLines: (s, v) => { s.myLines = v; },
  setAllLines: (s, v) => { s.allLines = v; },
  setCanViewAll: (s, v) => { s.canViewAll = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
